import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Sticky from './Sticky';
import StickyV2 from '../Sticky.sticky_commentbox';
export default withFeatureBranch({
    sticky_commentbox: StickyV2,
})(Sticky);
//# sourceMappingURL=index.js.map